import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import Button from 'components/form/Button';
import SeachInput from 'components/form/SeachInput';
import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import FollowUpUserDetails from '../FollowUpUserDetails';

import { fetchFollowupsList, fetchFollowupsUserList } from 'store/slices';
import { icons } from 'utils/constants';

const FollowUpUserList = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const { eID, followupID } = params;

  const [isLoading, setIsLoading] = useState(false);
  const [followUpsList, setFollowUpsList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [eventName, setEventName] = useState('');
  const fetchFollowupsData = async () => {
    const response = await dispatch(fetchFollowupsList());
    if (response?.status === 200) {
      const formattedData = response?.data?.followups_list?.map(
        (label, index) => ({
          id: index + 1,
          label,
        })
      );
      setFollowUpsList(formattedData);
    }
  };

  const fetchFollowupsUserData = async (eID, followupsName) => {
    if (!eID || !followupsName) return;
    setIsLoading(true);
    try {
      const payload = {
        event_id: eID,
        followups_status: String(followupsName),
      };
      const response = await dispatch(fetchFollowupsUserList(payload));
      if (response?.status === 200) {
        setUserList(response?.data?.user_details || []);
        setEventName(response?.data?.event_name || '');
      }
    } catch (error) {
      console.error('Error fetching followup user data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const followupsName = followUpsList.find(
    (item) => item.id === Number(followupID)
  )?.label;

  useEffect(() => {
    fetchFollowupsData();
  }, []);

  // Fetch the followups user list when both event ID and followup name are ready
  useEffect(() => {
    if (followupsName) {
      fetchFollowupsUserData(eID, followupsName);
    }
  }, [eID, followupsName]);

  const navigate = useNavigate();

  return (
    <div id="follow-up-detail-container">
      <Card className="cpt-20 cpe-20 cps-20 cpb-34 h-100">
        <div className="d-flex align-items-center justify-content-between cpb-10 border-bottom">
          <div className="d-flex align-items-center gap-2">
            <img
              src={icons.leftArrow}
              alt="back"
              className="h-21 pointer"
              onClick={() => {
                navigate(-1);
              }}
            />
            <div className="table-title">
              {followupsName || 'Follow-Up Details'}
            </div>
          </div>

          <div className="d-flex align-items-center flex-wrap gap-3">
            <div style={{ width: '220px' }}>
              <SeachInput
                placeholder="Search"
                value=""
                onChange={() => {}}
                onKeyDown={() => {}}
                onClick={() => {}}
                isSearchPointer
              />
            </div>
          </div>
        </div>

        <div className="cmb-16 text-16-400-27 color-black-olive cpt-20">
          {eventName}
        </div>

        {isLoading ? (
          <div className="center-flex cpt-50 cpb-50">
            <Loader size="md" />
          </div>
        ) : (
          <FollowUpUserDetails
            userDataList={userList}
            followupsName={followupsName}
          />
        )}
      </Card>
    </div>
  );
};

export default FollowUpUserList;
